import { render, staticRenderFns } from "./FavoritesProduct.vue?vue&type=template&id=06fb1c16"
import script from "./FavoritesProduct.vue?vue&type=script&lang=js"
export * from "./FavoritesProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeartIcon: require('/vercel/path0/components/icons/HeartIcon.vue').default})
